module.exports = __webpack_public_path__ + "src/assets/img/cmd-open-trunk.c844f354.svg";